import { render, staticRenderFns } from "./ProfileCardTv.vue?vue&type=template&id=79b33a4e&scoped=true&"
import script from "./ProfileCardTv.vue?vue&type=script&lang=ts&"
export * from "./ProfileCardTv.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCardTv.vue?vue&type=style&index=0&id=79b33a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b33a4e",
  null
  
)

export default component.exports